parasails.registerPage('editevent', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    eventID: '',
    eventData: {},
    virtualPageSlug: '',
    editEventFormData: {
      title: '',
      overallEventID: ''
    },
    syncing: false,
    formErrors: { /* … */ },
    cloudError: '',
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    //…
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    submittedEditEventForm: async function(result) {
      console.log('Editing Event: ' + this.editEventFormData.id);
      await _.extend(result, {
        id: this.editEventFormData.id,
        title: this.editEventFormData.title,
        overallEventID: this.editEventFormData.overallEventID
      });
    },

    handleParsingEditEventForm: function() {
      // Clear out any pre-existing error messages.
      this.formErrors = {};

      var argins = this.editEventFormData;

      // If there were any issues, they've already now been communicated to the user,
      // so simply return undefined.  (This signifies that the submission should be
      // cancelled.)
      if (Object.keys(this.formErrors).length > 0) {
        return;
      }

      return _.omit(argins, []);
    },

    generateEventID: async function() {
      this.editEventFormData.overallEventID = await Cloud.generateUuid();
      return;
    },

    addEventPart:  async function() {
      console.log('Got a add part request');
      return;
    },

    submittedAddEventForm: async function(result) {
      this.newEvent = await _.extend(result, {
        title: this.addEventFormData.title,
        userID: this.me.id,
        overallEventID: ''
      });

      this.selectedEventID = this.newEvent.newEvent.id;
      // Add the new event to the list
      this.events.unshift(this.newEvent);

      // Close the modal.
      this._clearAddEventModal();
    },

    deletePart: async function(partID) {
      console.log('Got a delete part request for part id ' + partID + ' and event id ' + this.editEventFormData.id);
      return;
    }
  }
});
